// noinspection ES6PreferShortImport

import React, {useState, useEffect, useRef} from 'react';
import PropTypes from 'prop-types';
import Skeleton from '@mui/material/Skeleton';
import {LoadableImageEnum} from '../../enums/Shared/LoadableImage.Enum';
import './LoadableImage.Style.scss';

export const LoadableImageComponent = ({
    src,
    alt,
    type,
    defaultImage,
    variant,
    classes,
    withOverlay,
    overlayText,
    overlayImage,
    onFinishLoading,
    style,
    skeletonClasses,
}) => {
    const [state, setState] = useState(false);
    const [localSrc, setLocalSrc] = useState('');
    const mounted = useRef(true);
    useEffect(() => {
        if (type === LoadableImageEnum.div.key) {
            const bgImg = new Image();
            bgImg.src = localSrc;
            bgImg.onload = () => {
                if (mounted.current) {
                    setState(true);
                    if (onFinishLoading) onFinishLoading();
                }
            };
            bgImg.onerror = () => {
                if (mounted.current && defaultImage) {
                    setState(true);
                    setLocalSrc(defaultImage);
                    if (onFinishLoading) onFinishLoading();
                }
            };
        }
    }, [mounted, onFinishLoading, localSrc, type, defaultImage]);
    useEffect(() => {
        setLocalSrc(src);
    }, [src]);
    useEffect(
        () => () => {
            mounted.current = false;
        },
        [],
    );

    return (
        <>
            {type === LoadableImageEnum.image.key && (
                <img
                    src={localSrc}
                    alt={alt}
                    className={`loadable-image-wrapper ${classes} ${
                        state ? ' show' : ' hidden'
                    }`}
                    onLoad={() => {
                        setState(true);
                        if (onFinishLoading) onFinishLoading();
                    }}
                    onError={() => {
                        setState(true);
                    }}
                />
            )}
            {type === LoadableImageEnum.div.key && state && (
                <div
                    className={`loadable-image-div-wrapper ${classes}`}
                    aria-label={alt}
                    role="img"
                    style={{
                        ...(style || {}),
                        backgroundImage: `url(${localSrc})`,
                    }}
                />
            )}
            {!state && src && (
                <div className={`loadable-skeleton-wrapper ${skeletonClasses || ''}`}>
                    <Skeleton variant={variant} style={{width: '100%', height: '100%'}} />
                </div>
            )}
            {withOverlay && (
                <div className="loadable-overlay">
                    {overlayText && <span>{overlayText}</span>}
                    {overlayImage && <span className={overlayImage} />}
                </div>
            )}
        </>
    );
};
LoadableImageComponent.propTypes = {
    src: PropTypes.string,
    defaultImage: PropTypes.string,
    alt: PropTypes.string.isRequired,
    type: PropTypes.oneOf(Object.values(LoadableImageEnum||{}).map((item) => item.key)),
    classes: PropTypes.string,
    onFinishLoading: PropTypes.func,
    withOverlay: PropTypes.bool,
    overlayText: PropTypes.string,
    variant: PropTypes.string,
    skeletonClasses: PropTypes.string,
    overlayImage: PropTypes.string,
    style: PropTypes.instanceOf(Object),
};
LoadableImageComponent.defaultProps = {
    src: undefined,
    type: LoadableImageEnum.div.key,
    defaultImage: undefined,
    withOverlay: false,
    overlayText: undefined,
    overlayImage: undefined,
    onFinishLoading: undefined,
    variant: undefined,
    skeletonClasses: undefined,
    style: undefined,
    classes: undefined,
};
